import HTTPService from "./httpService";

class AddressService extends HTTPService {}
const service = new AddressService('address');
export default service;